import React, { useState } from "react";
import { Button } from "./Button";
import { Dialog } from "./Dialog";
import { Field, Input } from "./Field";

interface ConfirmDialogProps {
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: "danger" | "default";
  loading?: boolean;
  /** Ações irreversíveis: o botão só habilita depois de digitar exatamente este texto. */
  confirmText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title,
  message,
  confirmLabel,
  cancelLabel = "Cancelar",
  tone = "danger",
  loading = false,
  confirmText,
  onConfirm,
  onCancel,
}) => {
  const [typed, setTyped] = useState("");
  const canConfirm = !confirmText || typed.trim() === confirmText.trim();

  return (
    <Dialog
      open
      onClose={onCancel}
      closeDisabled={loading}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={tone === "danger" ? "danger" : "primary"}
            onClick={onConfirm}
            loading={loading}
            disabled={!canConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="text-body text-fg-muted">{message}</div>
      {confirmText && (
        <Field
          className="mt-4"
          label={
            <>
              Digite <strong className="font-semibold">{confirmText}</strong> para confirmar
            </>
          }
        >
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} autoComplete="off" />
        </Field>
      )}
    </Dialog>
  );
};
